import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import styled from 'styled-components';
import { PageTitle } from '../CoachDashboard/styles';
import TrainingSessions from '../TrainingSessions/TrainingSessions';
import { athleteAPI } from '../../services/api';

const Container = styled.div`
  width: 100%;
`;

const JumperTrainingSessions: React.FC = () => {
  const { user } = useAuth();
  const [athleteId, setAthleteId] = useState<string | null>(null);
  const [validAthleteIds, setValidAthleteIds] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadAthleteData = async () => {
      if (user?.role === 'athlete') {
        try {
          // Get the athlete record for this user
          const athlete = await athleteAPI.getMyAthlete();
          const ownAthleteId = athlete._id.toString();
          setAthleteId(ownAthleteId);
          
          // Get all athletes to find coach athlete records that reference this athlete
          const allAthletes = await athleteAPI.getAll();
          
          console.log('=== JumperTrainingSessions Debug ===');
          console.log('Own Athlete ID:', ownAthleteId);
          console.log('Total Athletes:', allAthletes.length);
          
          // Find all coach athlete records that reference this athlete
          // The athleteId field in coach athlete records is a STRING that matches the athlete's _id
          // These are records created by coaches when they connect an athlete
          const coachAthleteRecords = allAthletes.filter((a: any) => {
            // Check if this athlete record has an athleteId field that matches our own ID
            // The athleteId field is a string, so we need to compare as strings
            // Exclude the athlete's own record (where _id matches ownAthleteId)
            const matches = a.athleteId && 
                           a.athleteId.toString() === ownAthleteId &&
                           a._id.toString() !== ownAthleteId; // Exclude own record
            
            if (matches) {
              console.log('Found Coach Athlete Record:', {
                _id: a._id.toString(),
                firstName: a.firstName,
                lastName: a.lastName,
                athleteId: a.athleteId,
                userId: a.userId
              });
            }
            
            return matches;
          });
          
          console.log('Coach Athlete Records Found:', coachAthleteRecords.length);
          
          // Build list of valid athlete IDs: own ID + coach athlete record IDs
          // These are the IDs that might appear in ground training records
          // When a coach creates a ground training record, they select an athlete from their list,
          // which uses the coach's athlete record ID (not the original athlete's ID)
          const validIds = [
            ownAthleteId,
            ...coachAthleteRecords.map((a: any) => String(a._id))
          ].filter((id, index, self) => self.indexOf(id) === index); // Remove duplicates
          
          console.log('Valid Athlete IDs:', validIds);
          
          setValidAthleteIds(validIds);
        } catch (error) {
          console.error('Error loading athlete:', error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadAthleteData();
  }, [user]);

  if (isLoading) {
    return (
      <Container>
        <PageTitle>Training Sessions</PageTitle>
        <p style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-gray)' }}>
          Loading...
        </p>
      </Container>
    );
  }

  // Pass athleteId and validAthleteIds to filter sessions and records
  return (
    <Container>
      <TrainingSessions athleteId={athleteId || undefined} validAthleteIds={validAthleteIds} />
    </Container>
  );
};

export default JumperTrainingSessions;
